import React from 'react'
import { useSelector } from 'react-redux'
import DashboardComponent from '../../components/dashboardComponents/DashboardComponent';

const Dashboard= () => {
    const headerName= useSelector(state => state.authendicationReducer.headerName); 

    if (headerName === 'Dashboard') {
        return <DashboardComponent />
    } else {
        // If headerName doesn't match, return null or any other desired behavior
        return null; // or any other fallback component
    }
}

export default Dashboard